// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sauser-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .sauser-form-container {
    padding: 1rem;
  }
}
.sauser-form-container .sauser-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  animation: user-form-fade-in 0.3s ease-out;
  width: 70%;
  max-width: 600px;
}
@media (max-width: 768px) {
  .sauser-form-container .sauser-form-wrapper {
    padding: 1.5rem;
    width: 100%;
  }
}
@media (max-width: 480px) {
  .sauser-form-container .sauser-form-wrapper {
    padding: 1rem;
  }
}
.sauser-form-container .sauser-form-header {
  text-align: center;
}
.sauser-form-container .sauser-form-header .sauser-form-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .sauser-form-container .sauser-form-header .sauser-form-title {
    font-size: 1.5rem;
  }
}
.sauser-form-container .sauser-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.sauser-form-container > h1 {
  display: none;
}
.sauser-form-container form,
.sauser-form-container .form-content {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .sauser-form-container form,
  .sauser-form-container .form-content {
    padding: 0;
    width: 100%;
  }
}
@media (max-width: 480px) {
  .sauser-form-container form,
  .sauser-form-container .form-content {
    padding: 0;
  }
}
.sauser-form-container .form-section {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}
.sauser-form-container .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.sauser-form-container .form-section h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e5e7eb;
  position: relative;
}
.sauser-form-container .form-row {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}
.sauser-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .sauser-form-container .form-row {
    flex-direction: column;
    gap: 1rem;
  }
}
.sauser-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
}
.sauser-form-container .form-group:last-child {
  margin-bottom: 0;
}
.sauser-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
  position: relative;
}
.sauser-form-container .form-group label::after {
  content: "*";
  color: #ef4444;
  margin-left: 0.25rem;
  font-weight: 600;
}
.sauser-form-container .form-group input,
.sauser-form-container .form-group select,
.sauser-form-container .form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.75rem;
  transition: all 0.2s ease-in-out;
}
.sauser-form-container .form-group input:focus,
.sauser-form-container .form-group select:focus,
.sauser-form-container .form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: #ffffff;
}
.sauser-form-container .form-group input:hover:not(:focus),
.sauser-form-container .form-group select:hover:not(:focus),
.sauser-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.sauser-form-container .form-group input::placeholder,
.sauser-form-container .form-group select::placeholder,
.sauser-form-container .form-group textarea::placeholder {
  color: #9ca3af;
  font-style: italic;
}
.sauser-form-container .form-group input:disabled,
.sauser-form-container .form-group select:disabled,
.sauser-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
  border-color: #e5e7eb;
}
.sauser-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 1.25rem 1.25rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.sauser-form-container .form-group select:disabled {
  cursor: not-allowed;
}
.sauser-form-container .form-group select option {
  padding: 0.5rem;
  background: #ffffff;
  color: #374151;
}
.sauser-form-container .form-group textarea {
  min-height: 100px;
  resize: vertical;
  padding: 0.75rem;
}
.sauser-form-container .form-group .error {
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.375rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.sauser-form-container .form-group .error::before {
  content: "⚠";
  font-size: 0.875rem;
}
.sauser-form-container .form-group.toggle-group {
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}
.sauser-form-container .form-group.toggle-group label {
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.sauser-form-container .form-group.toggle-group label::after {
  display: none;
}
.sauser-form-container .form-group.toggle-group .toggle-switch {
  position: relative;
  width: 48px;
  height: 24px;
  background-color: #d1d5db;
  border-radius: 12px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  border: none;
  padding: 0;
  min-height: auto;
}
.sauser-form-container .form-group.toggle-group .toggle-switch::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.sauser-form-container .form-group.toggle-group .toggle-switch.active {
  background-color: var(--primary-color);
}
.sauser-form-container .form-group.toggle-group .toggle-switch.active::before {
  transform: translateX(24px);
}
.sauser-form-container .form-group.toggle-group .toggle-switch:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.sauser-form-container .form-group.toggle-group .toggle-switch:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.sauser-form-container .form-group.company-search {
  position: relative;
}
.sauser-form-container .form-group.company-search .search-input {
  position: relative;
}
.sauser-form-container .form-group.company-search .search-input input {
  padding-right: 2.5rem;
}
.sauser-form-container .form-group.company-search .dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item {
  padding: 0.75rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #f3f4f6;
}
.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item:last-child {
  border-bottom: none;
}
.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item:hover {
  background-color: #f9fafb;
}
.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item.selected {
  background-color: #eff6ff;
  color: #1d4ed8;
  font-weight: 500;
}
.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item.no-results {
  color: #6b7280;
  font-style: italic;
  cursor: default;
}
.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item.no-results:hover {
  background-color: transparent;
}
.sauser-form-container .form-group.company-search .selected-company {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  margin-top: 0.5rem;
}
.sauser-form-container .form-group.company-search .selected-company .company-name {
  font-weight: 500;
  color: #0369a1;
}
.sauser-form-container .form-group.company-search .selected-company .clear-button {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: all 0.15s ease;
}
.sauser-form-container .form-group.company-search .selected-company .clear-button:hover {
  background-color: #e5e7eb;
  color: #374151;
}
.sauser-form-container button[type=submit] {
  width: 100%;
  padding: 0.875rem 2rem;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 2rem;
  min-height: 2.75rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(34, 197, 94, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.sauser-form-container button[type=submit]::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}
.sauser-form-container button[type=submit]:active:not(:disabled) {
  transform: translateY(0);
}
.sauser-form-container button[type=submit]:focus {
  outline: none;
}
.sauser-form-container button[type=submit]:disabled {
  background: #d1d5db;
  color: #6b7280;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none !important;
  box-shadow: none;
}
.sauser-form-container button[type=submit]:disabled::before {
  display: none;
}
@media (max-width: 768px) {
  .sauser-form-container button[type=submit] {
    padding: 1rem;
    font-size: 0.8125rem;
  }
}
.sauser-form-container .loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 1.125rem;
  color: #6b7280;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 70%;
  max-width: 600px;
}
@media (max-width: 768px) {
  .sauser-form-container .loading {
    width: 100%;
  }
}

@keyframes user-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .sauser-form-container .sauser-form-wrapper {
    width: 100%;
  }
  .sauser-form-container .loading {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .sauser-form-container {
    padding: 0.5rem;
  }
  .sauser-form-container .sauser-form-wrapper {
    padding: 1rem;
  }
  .sauser-form-container .sauser-form-header .sauser-form-title {
    font-size: 1.25rem;
  }
  .sauser-form-container .form-group input,
  .sauser-form-container .form-group select,
  .sauser-form-container .form-group textarea {
    padding: 0.625rem;
    font-size: 0.8125rem;
  }
  .sauser-form-container button[type=submit] {
    padding: 0.75rem 1.5rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .sauser-form-container {
    background: white;
    padding: 0;
  }
  .sauser-form-container .sauser-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .sauser-form-container button {
    display: none;
  }
}
.visibility-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.visibility-section .loading-rights {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6b7280;
  font-style: italic;
}
.visibility-section .no-rights {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6b7280;
  font-style: italic;
}
.visibility-section .visibility-toggles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }
}
.visibility-section .toggle-label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  text-transform: capitalize;
}
.visibility-section .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: pointer;
}
.visibility-section .toggle-switch input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.visibility-section .toggle-switch input:checked + .slider {
  background-color: var(--primary-color);
}
.visibility-section .toggle-switch input:checked + .slider::before {
  transform: translateX(26px);
}
.visibility-section .toggle-switch input:focus + .slider {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.visibility-section .toggle-switch input:disabled + .slider {
  opacity: 0.6;
  cursor: not-allowed;
}
.visibility-section .toggle-switch .slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: all 0.3s ease;
}
.visibility-section .toggle-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.visibility-section .toggle-switch:hover .slider {
  background-color: #9ca3af;
}
input:checked + .visibility-section .toggle-switch:hover .slider {
  background-color: #2563eb;
}

.sauser-form-container input:focus-visible,
.sauser-form-container select:focus-visible,
.sauser-form-container textarea:focus-visible,
.sauser-form-container button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.sauser-form-container .checkbox-group input[type=checkbox]:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.sauser-form-container .toggle-switch input:focus-visible + .slider {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/SAUserForm/SAUserForm.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;AAAE;EATF;IAUI,aAAA;EAGF;AACF;AADE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iFAAA;EACA,0CAAA;EACA,UAAA;EACA,gBAAA;AAGJ;AADI;EAVF;IAWI,eAAA;IACA,WAAA;EAIJ;AACF;AAFI;EAfF;IAgBI,aAAA;EAKJ;AACF;AAFE;EACE,kBAAA;AAIJ;AADI;EACE,iBAAA;EACD,gBAAA;EACC,cAAA;EACA,SAAA;AAGN;AADM;EANF;IAOI,iBAAA;EAIN;AACF;AAAE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAEJ;AACE;EACE,aAAA;AACJ;AAEE;;EAEE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAAJ;AAEI;EATF;;IAUI,UAAA;IACA,WAAA;EAEJ;AACF;AAAI;EAdF;;IAeI,UAAA;EAIJ;AACF;AADE;EAEE,sBAAA;EACA,gCAAA;AAEJ;AAAI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAEN;AACI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;AACN;AAEE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EATF;IAUI,sBAAA;IACA,SAAA;EAAJ;AACF;AAGE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAFN;AAIM;EACE,YAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;AAFR;AAKI;;;EAGE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;AAHN;AAKM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;EACA,mBAAA;AADR;AAIM;;;EACE,qBAAA;AAAR;AAGM;;;EACE,cAAA;EACA,kBAAA;AACR;AAEM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AAER;AAEI;EACE,gBAAA;EACA,yDAAA;EACA,yCAAA;EACA,4BAAA;EACA,gCAAA;EACA,qBAAA;EACA,eAAA;AAAN;AAEM;EACE,mBAAA;AAAR;AAGM;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AADR;AAKI;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHN;AAMI;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAJN;AAMM;EACE,YAAA;EACA,mBAAA;AAJR;AASI;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAPN;AASM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAPR;AASQ;EACE,aAAA;AAPV;AAWM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AATR;AAWQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,wCAAA;AATV;AAYQ;EACE,sCAAA;AAVV;AAYU;EACE,2BAAA;AAVZ;AAcQ;EACE,0BAAA;EACA,mBAAA;AAZV;AAeQ;EACE,YAAA;EACA,mBAAA;AAbV;AAmBI;EACE,kBAAA;AAjBN;AAmBM;EACE,kBAAA;AAjBR;AAmBQ;EACE,qBAAA;AAjBV;AA8BM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,6CAAA;AA5BR;AA8BQ;EACE,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,gCAAA;AA5BV;AA8BU;EACE,mBAAA;AA5BZ;AA+BU;EACE,yBAAA;AA7BZ;AAgCU;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AA9BZ;AAiCU;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA/BZ;AAiCY;EACE,6BAAA;AA/Bd;AAqCM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;AAnCR;AAqCQ;EACE,gBAAA;EACA,cAAA;AAnCV;AAsCQ;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;AApCV;AAsCU;EACE,yBAAA;EACA,cAAA;AApCZ;AA2CE;EACE,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzCJ;AA2CI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AAzCN;AAsDI;EACE,wBAAA;AApDN;AAuDI;EACE,aAAA;AArDN;AAwDI;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;AAtDN;AAwDM;EACE,aAAA;AAtDR;AA0DI;EA9DF;IA+DI,aAAA;IACA,oBAAA;EAvDJ;AACF;AA0DE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6CAAA;EACA,UAAA;EACA,gBAAA;AAxDJ;AA0DI;EAdF;IAeI,WAAA;EAvDJ;AACF;;AA2DA;EACE;IACE,UAAA;IACA,uCAAA;EAxDF;EA2DA;IACE,UAAA;IACA,iCAAA;EAzDF;AACF;AA4DA;EAEI;IACE,WAAA;EA3DJ;EA8DE;IACE,WAAA;EA5DJ;AACF;AAgEA;EACE;IACE,eAAA;EA9DF;EAgEE;IACE,aAAA;EA9DJ;EAkEI;IACE,kBAAA;EAhEN;EAsEI;;;IAGE,iBAAA;IACA,oBAAA;EApEN;EAwEE;IACE,uBAAA;IACA,oBAAA;EAtEJ;AACF;AA2EA;EACE;IACE,iBAAA;IACA,UAAA;EAzEF;EA2EE;IACE,gBAAA;IACA,sBAAA;EAzEJ;EA4EE;IACE,aAAA;EA1EJ;AACF;AAgFE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AA9EJ;AAiFE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AA/EJ;AAkFE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAhFJ;AAmFE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAjFJ;AAmFI;EANF;IAOI,4DAAA;IACA,YAAA;EAhFJ;AACF;AAmFE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AAjFJ;AAoFE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAlFJ;AAoFI;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAlFN;AAoFM;EACE,sCAAA;AAlFR;AAoFQ;EACE,2BAAA;AAlFV;AAsFM;EACE,6CAAA;AApFR;AAuFM;EACE,YAAA;EACA,mBAAA;AArFR;AAyFI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAvFN;AAyFM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAvFR;AA2FI;EACE,yBAAA;AAzFN;AA2FM;EACE,yBAAA;AAzFR;;AAkGE;;;;EAIE,0BAAA;EACA,mBAAA;AA/FJ;AAkGE;EACE,0BAAA;EACA,mBAAA;AAhGJ;AAmGE;EACE,0BAAA;EACA,mBAAA;AAjGJ","sourcesContent":["@charset \"UTF-8\";\n.sauser-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n@media (max-width: 768px) {\n  .sauser-form-container {\n    padding: 1rem;\n  }\n}\n.sauser-form-container .sauser-form-wrapper {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  animation: user-form-fade-in 0.3s ease-out;\n  width: 70%;\n  max-width: 600px;\n}\n@media (max-width: 768px) {\n  .sauser-form-container .sauser-form-wrapper {\n    padding: 1.5rem;\n    width: 100%;\n  }\n}\n@media (max-width: 480px) {\n  .sauser-form-container .sauser-form-wrapper {\n    padding: 1rem;\n  }\n}\n.sauser-form-container .sauser-form-header {\n  text-align: center;\n}\n.sauser-form-container .sauser-form-header .sauser-form-title {\n  font-size: 1.6rem;\n  font-weight: 500;\n  color: #374151;\n  margin: 0;\n}\n@media (max-width: 768px) {\n  .sauser-form-container .sauser-form-header .sauser-form-title {\n    font-size: 1.5rem;\n  }\n}\n.sauser-form-container .sauser-form-divider {\n  border: none;\n  border-top: 1px solid #e5e7eb;\n  margin: 1.5rem 0;\n}\n.sauser-form-container > h1 {\n  display: none;\n}\n.sauser-form-container form,\n.sauser-form-container .form-content {\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  animation: none;\n  width: 100%;\n}\n@media (max-width: 768px) {\n  .sauser-form-container form,\n  .sauser-form-container .form-content {\n    padding: 0;\n    width: 100%;\n  }\n}\n@media (max-width: 480px) {\n  .sauser-form-container form,\n  .sauser-form-container .form-content {\n    padding: 0;\n  }\n}\n.sauser-form-container .form-section {\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n.sauser-form-container .form-section:last-of-type {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.sauser-form-container .form-section h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 1.5rem 0;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid #e5e7eb;\n  position: relative;\n}\n.sauser-form-container .form-row {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n.sauser-form-container .form-row:last-child {\n  margin-bottom: 0;\n}\n@media (max-width: 768px) {\n  .sauser-form-container .form-row {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n.sauser-form-container .form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1.5rem;\n}\n.sauser-form-container .form-group:last-child {\n  margin-bottom: 0;\n}\n.sauser-form-container .form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: #374151;\n  position: relative;\n}\n.sauser-form-container .form-group label::after {\n  content: \"*\";\n  color: #ef4444;\n  margin-left: 0.25rem;\n  font-weight: 600;\n}\n.sauser-form-container .form-group input,\n.sauser-form-container .form-group select,\n.sauser-form-container .form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: #374151;\n  background: #ffffff;\n  box-sizing: border-box;\n  min-height: 2.75rem;\n  transition: all 0.2s ease-in-out;\n}\n.sauser-form-container .form-group input:focus,\n.sauser-form-container .form-group select:focus,\n.sauser-form-container .form-group textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  background: #ffffff;\n}\n.sauser-form-container .form-group input:hover:not(:focus),\n.sauser-form-container .form-group select:hover:not(:focus),\n.sauser-form-container .form-group textarea:hover:not(:focus) {\n  border-color: #9ca3af;\n}\n.sauser-form-container .form-group input::placeholder,\n.sauser-form-container .form-group select::placeholder,\n.sauser-form-container .form-group textarea::placeholder {\n  color: #9ca3af;\n  font-style: italic;\n}\n.sauser-form-container .form-group input:disabled,\n.sauser-form-container .form-group select:disabled,\n.sauser-form-container .form-group textarea:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n  border-color: #e5e7eb;\n}\n.sauser-form-container .form-group select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center;\n  background-repeat: no-repeat;\n  background-size: 1.25rem 1.25rem;\n  padding-right: 2.5rem;\n  cursor: pointer;\n}\n.sauser-form-container .form-group select:disabled {\n  cursor: not-allowed;\n}\n.sauser-form-container .form-group select option {\n  padding: 0.5rem;\n  background: #ffffff;\n  color: #374151;\n}\n.sauser-form-container .form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n  padding: 0.75rem;\n}\n.sauser-form-container .form-group .error {\n  color: #ef4444;\n  font-size: 0.75rem;\n  margin-top: 0.375rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n.sauser-form-container .form-group .error::before {\n  content: \"⚠\";\n  font-size: 0.875rem;\n}\n.sauser-form-container .form-group.toggle-group {\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n.sauser-form-container .form-group.toggle-group label {\n  margin-bottom: 0;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: #374151;\n}\n.sauser-form-container .form-group.toggle-group label::after {\n  display: none;\n}\n.sauser-form-container .form-group.toggle-group .toggle-switch {\n  position: relative;\n  width: 48px;\n  height: 24px;\n  background-color: #d1d5db;\n  border-radius: 12px;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  min-height: auto;\n}\n.sauser-form-container .form-group.toggle-group .toggle-switch::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n.sauser-form-container .form-group.toggle-group .toggle-switch.active {\n  background-color: var(--primary-color);\n}\n.sauser-form-container .form-group.toggle-group .toggle-switch.active::before {\n  transform: translateX(24px);\n}\n.sauser-form-container .form-group.toggle-group .toggle-switch:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n.sauser-form-container .form-group.toggle-group .toggle-switch:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.sauser-form-container .form-group.company-search {\n  position: relative;\n}\n.sauser-form-container .form-group.company-search .search-input {\n  position: relative;\n}\n.sauser-form-container .form-group.company-search .search-input input {\n  padding-right: 2.5rem;\n}\n.sauser-form-container .form-group.company-search .dropdown-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-top: none;\n  border-radius: 0 0 0.375rem 0.375rem;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item {\n  padding: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  border-bottom: 1px solid #f3f4f6;\n}\n.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item:last-child {\n  border-bottom: none;\n}\n.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item:hover {\n  background-color: #f9fafb;\n}\n.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item.selected {\n  background-color: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 500;\n}\n.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item.no-results {\n  color: #6b7280;\n  font-style: italic;\n  cursor: default;\n}\n.sauser-form-container .form-group.company-search .dropdown-list .dropdown-item.no-results:hover {\n  background-color: transparent;\n}\n.sauser-form-container .form-group.company-search .selected-company {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem;\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 0.375rem;\n  margin-top: 0.5rem;\n}\n.sauser-form-container .form-group.company-search .selected-company .company-name {\n  font-weight: 500;\n  color: #0369a1;\n}\n.sauser-form-container .form-group.company-search .selected-company .clear-button {\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: all 0.15s ease;\n}\n.sauser-form-container .form-group.company-search .selected-company .clear-button:hover {\n  background-color: #e5e7eb;\n  color: #374151;\n}\n.sauser-form-container button[type=submit] {\n  width: 100%;\n  padding: 0.875rem 2rem;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 2rem;\n  min-height: 2.75rem;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 6px -1px rgba(34, 197, 94, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.sauser-form-container button[type=submit]::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n.sauser-form-container button[type=submit]:active:not(:disabled) {\n  transform: translateY(0);\n}\n.sauser-form-container button[type=submit]:focus {\n  outline: none;\n}\n.sauser-form-container button[type=submit]:disabled {\n  background: #d1d5db;\n  color: #6b7280;\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none !important;\n  box-shadow: none;\n}\n.sauser-form-container button[type=submit]:disabled::before {\n  display: none;\n}\n@media (max-width: 768px) {\n  .sauser-form-container button[type=submit] {\n    padding: 1rem;\n    font-size: 0.8125rem;\n  }\n}\n.sauser-form-container .loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  font-size: 1.125rem;\n  color: #6b7280;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  width: 70%;\n  max-width: 600px;\n}\n@media (max-width: 768px) {\n  .sauser-form-container .loading {\n    width: 100%;\n  }\n}\n\n@keyframes user-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n@media (max-width: 768px) {\n  .sauser-form-container .sauser-form-wrapper {\n    width: 100%;\n  }\n  .sauser-form-container .loading {\n    width: 100%;\n  }\n}\n@media (max-width: 480px) {\n  .sauser-form-container {\n    padding: 0.5rem;\n  }\n  .sauser-form-container .sauser-form-wrapper {\n    padding: 1rem;\n  }\n  .sauser-form-container .sauser-form-header .sauser-form-title {\n    font-size: 1.25rem;\n  }\n  .sauser-form-container .form-group input,\n  .sauser-form-container .form-group select,\n  .sauser-form-container .form-group textarea {\n    padding: 0.625rem;\n    font-size: 0.8125rem;\n  }\n  .sauser-form-container button[type=submit] {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.8125rem;\n  }\n}\n@media print {\n  .sauser-form-container {\n    background: white;\n    padding: 0;\n  }\n  .sauser-form-container .sauser-form-wrapper {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n  .sauser-form-container button {\n    display: none;\n  }\n}\n.visibility-section h3 {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #374151;\n  margin: 0 0 1rem 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.visibility-section .loading-rights {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  color: #6b7280;\n  font-style: italic;\n}\n.visibility-section .no-rights {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  color: #6b7280;\n  font-style: italic;\n}\n.visibility-section .visibility-toggles {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n@media (max-width: 768px) {\n  .visibility-section .visibility-toggles {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 0.75rem;\n  }\n}\n.visibility-section .toggle-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  text-transform: capitalize;\n}\n.visibility-section .toggle-switch {\n  position: relative;\n  width: 50px;\n  height: 24px;\n  cursor: pointer;\n}\n.visibility-section .toggle-switch input {\n  opacity: 0;\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n.visibility-section .toggle-switch input:checked + .slider {\n  background-color: var(--primary-color);\n}\n.visibility-section .toggle-switch input:checked + .slider::before {\n  transform: translateX(26px);\n}\n.visibility-section .toggle-switch input:focus + .slider {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n.visibility-section .toggle-switch input:disabled + .slider {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.visibility-section .toggle-switch .slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #d1d5db;\n  border-radius: 24px;\n  transition: all 0.3s ease;\n}\n.visibility-section .toggle-switch .slider::before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  top: 3px;\n  background-color: white;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n.visibility-section .toggle-switch:hover .slider {\n  background-color: #9ca3af;\n}\ninput:checked + .visibility-section .toggle-switch:hover .slider {\n  background-color: #2563eb;\n}\n\n.sauser-form-container input:focus-visible,\n.sauser-form-container select:focus-visible,\n.sauser-form-container textarea:focus-visible,\n.sauser-form-container button:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n.sauser-form-container .checkbox-group input[type=checkbox]:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n.sauser-form-container .toggle-switch input:focus-visible + .slider {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
